import { THttpService } from '@/services/HttpService';

import { getValue } from '@/helpers/GetValueHelper';

import {
  TBanksObj,
  TModalContent,
  TNestedContentField,
  TResponseContent,
} from './types';

export const formatSuccess = async (
  data: TResponseContent,
): Promise<TModalContent> => {
  const base = (index: number) => `items[0].contentFields[${index}]`;

  const modalTitle = getValue(
    data,
    `${base(0)}.contentFieldValue.data`,
  ) as string;

  const modalDescription = getValue(
    data,
    `${base(1)}.contentFieldValue.data`,
  ) as string;

  const modalCtaLabel = getValue(
    data,
    `${base(2)}.contentFieldValue.data`,
  ) as string;

  const modalNotes = getValue(
    data,
    `${base(3)}.contentFieldValue.data`,
  ) as string;

  const banks = [];
  banks.push(
    createBankObj(
      getValue(data, `${base(4)}.nestedContentFields`) as TNestedContentField[],
    ),
  );
  banks.push(
    createBankObj(
      getValue(data, `${base(5)}.nestedContentFields`) as TNestedContentField[],
    ),
  );

  banks.push(
    createBankObj(
      getValue(data, `${base(6)}.nestedContentFields`) as TNestedContentField[],
    ),
  );

  return {
    modalTitle,
    modalDescription,
    modalCtaLabel,
    modalNotes,
    banks,
  };
};

const createBankObj = (bankContent: TNestedContentField[]) => {
  const resultObj: TBanksObj = {
    name:
      bankContent.find(item => item.name === 'Name')?.contentFieldValue.data ||
      '',
    image:
      bankContent.find(item => item.name === 'image')?.contentFieldValue
        .document?.contentUrl || '',
  };

  return resultObj;
};

export const formatError = () => {
  return undefined;
};

export const getModalContent = async (
  api: THttpService,
  key: string,
): Promise<TModalContent | undefined> => {
  const query = encodeURI(`filter=(title+eq+'${key}')`);
  const path =
    '/o/headless-delivery/v1.0/sites/20124/structured-contents?flatten=true&';

  let data = {};
  try {
    const response = await api.get(path + query);
    data = response.data;
    return await formatSuccess(data as TResponseContent);
  } catch (error) {
    return formatError();
  }
};
